import React from 'react';
import classNames from 'classnames';

import { PROOF_SOURCE, PROOF_STATS } from '../../constants';

import styles from './styles.module.css';

const ProofBand: React.FC = () => (
  <section className={styles.proof} id="proof">
    <div className={styles.shell}>
      <div className={styles.head}>
        <div className={styles.eyebrow}>By the numbers</div>
        <h2 className={styles.heading}>
          Resale isn&apos;t a trend.
          <br />
          It&apos;s <em>where shoppers are.</em>
        </h2>
      </div>

      <div className={styles.grid}>
        {PROOF_STATS.map((stat) => (
          <div
            key={stat.copy}
            className={classNames(styles.cell, {
              [styles.featured]: stat.featured
            })}
          >
            <div className={styles.num}>
              {stat.value}
              {stat.suffix && <small>{stat.suffix}</small>}
            </div>
            <div className={styles.copy}>{stat.copy}</div>
          </div>
        ))}
      </div>

      <div className={styles.foot}>{PROOF_SOURCE}</div>
    </div>
  </section>
);

export default ProofBand;
